/*eslint-disable no-script-url*/
/*global gtag*/
import React, { Component } from 'react';
import * as Common from '../components/Common';
import * as moment from 'moment';
import 'moment/locale/ko';
import { isIOS } from "react-device-detect";

import EventBranchRow from '../components/EventBranchRow';
import CurrentPosLabel from '../components/CurrentPosLabel';
import Reflux from 'reflux';
import { Actions } from '../components/Actions';

import BranchRegionPop from '../components/BranchRegionPop';
import BranchLocationPop from '../components/BranchLocationPop';

class EventBranch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      branch_event_id: 0,
      title: '',
      searchType: 'distance',
      centerLat: 0,
      centerLon: 0,
      selSido: '',
      selSigungu: '',
      selDong: '',
      branchList: null,
      branch_id: 0,
      onessaas_branch_id: 0,
      pop_branch_id: 0,
      isOpenRegionPop: false,
      isOpenLocationPop: false,
      valueGroups: {},
      optionGroups: {}
    }
  }

  componentDidMount() {
    const { match: { params } } = this.props;
    this.setState({ branch_event_id: params.branch_event_id });
    this._getEventBranch(params.branch_event_id);
    this._doSelectSearchTypeEvent(this.state.searchType);
  }
  
  _initState = (searchType) => {
    this.setState({
      searchType: searchType,
      branchList: null,
      branch_id: 0,
      onessaas_branch_id: 0,
      pop_branch_id: 0
    });
  }

  _doSelectSearchTypeEvent = (searchType) => {
    var lat = 0;
    var lon = 0;

    this._initState(searchType);

    var params = {
      onesBranchType: 'TSC',
      orderBy: searchType,
      addressSidoname: this.state.selSido,
      addressSigunguname: this.state.selSigungu,
      addressDongname: this.state.selDong
    };

    if(searchType === 'distance') {
      Actions.loadingState(true);
      if(navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          lat = position.coords.latitude; // 위도(y)
          lon = position.coords.longitude; // 경도(x)

          if(isIOS) {
            Common.callApi('/coord2regioncode', 'get', {x: lon, y: lat})
            .then(result => {
              var _resultData = result.resultData;
              
              this.setState({
                centerLat: lat,
                centerLon: lon,
                currSido: _resultData.region_1depth_name,
                currSigungu: _resultData.region_2depth_name,
                currDong: _resultData.region_3depth_name
              });
  
              params.latitude = lat;
              params.longitude = lon;
              params.isExperience = 1;
              params.branch_event_id = this.state.branch_event_id;
        
              this._getBranches(params);
            });
          } else {
            var _body = {
              method: 'get',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'KakaoAK 2fd61beb45e50a50ecfc63bbef4de789'
              }
            }
  
            fetch('//dapi.kakao.com/v2/local/geo/coord2regioncode.json?x=' + lon + '&y=' + lat, _body)
            .then(response => response.json())
            .then(json => {
              var _documents = json.documents;
              if(_documents.length > 0) {
                var _x = _documents[0].x;
                var _y = _documents[0].y;
  
                this.setState({
                  centerLat: _y,
                  centerLon: _x,
                  currSido: _documents[0].region_1depth_name,
                  currSigungu: _documents[0].region_2depth_name,
                  currDong: _documents[0].region_3depth_name
                });
  
                params.latitude = _y;
                params.longitude = _x;
                params.branch_event_id = this.state.branch_event_id;
          
                this._getBranches(params);
              }
            })
            .catch(err => {
              Actions.loadingState(false);
              Actions.alertOpen({msg: err}, [{type: 'ok', label: '확인'}]);
            });
          }
        }, (error) => {
          Actions.loadingState(false);
          Actions.alertOpen({msg: '위치정보를 가져올 수 없습니다.<br/>지역 검색으로 변경합니다.'}, [{type: 'ok', label: '확인', callback: this._doSelectSearchTypeEvent, param: 'location'}]);
        });
      } else {
        Actions.loadingState(false);
        Actions.alertOpen({msg: '위치정보를 가져올 수 없습니다.<br/>지역 검색으로 변경합니다.'}, [{type: 'ok', label: '확인', callback: this._doSelectSearchTypeEvent, param: 'location'}]);
      }
    } else if(searchType === 'location') {
      this._getBranches(params);
    }
  }

  _doOpenRequestFormPop = (e) => {
    var type = e.target.dataset.type;
    var branch_id = e.target.dataset.branch_id;

    if(type === 'region') {
      this.setState({ isOpenRegionPop: true });
    } else if(type === 'location') {
      this.setState({ isOpenLocationPop: true });
    }
    this.setState({ pop_branch_id: branch_id });

    Common.disableScroll();
  }

  _doCloseRequestFormPop = (e) => {
    var type = e.target.dataset.type;

    if(type === 'region') {
      var _sido = e.target.dataset.sido;
      var _sigungu = e.target.dataset.sigungu;
      var _dong = e.target.dataset.dong; 

      this._initState(this.state.searchType);

      this.setState({
        isOpenRegionPop: false,
        selSido: _sido,
        selSigungu: _sigungu,
        selDong: _dong
      });

      var params = {
        onesBranchType: 'TSC',
        orderBy: this.state.searchType,
        addressSidoname: _sido,
        addressSigunguname: _sigungu,
        addressDongname: _dong,
        latitude: this.state.centerLat,
        longitude: this.state.centerLon,
        branch_event_id: this.state.branch_event_id
      };

      this._getBranches(params);
    } else if(type === 'location') {
      this.setState({ isOpenLocationPop: false });
    }

    Common.enableScroll();
  }

  _getEventBranch = async (branch_event_id) => {
    const result = await Common.callApi('/hp/branchEvent/' + branch_event_id, 'get');

    if(result.resultCode === 'success') {
      this.setState({ title: result.resultData.title });
    }
  }

  _getBranches = async (params) => {
    const result = await Common.callApi('/hp/eventBranches', 'post', params);

    if(result.resultCode === 'success') {
      let _resultList = result.resultDataList;
      this.setState({ branchList: _resultList });
    }
  }

  _branchRow0 = (e) => {
    if(e && e._input) e._input.click();
  }

  render() {
    return (
      <div>
        <div id="skipNavi">
          <h1 className="blind">TOZ StudyCenter 스킵네비게이션</h1>
          <ul>
            <li><a href="#contents" className="skipLink">본문바로가기</a></li>
            <li><a href="#topmenu" className="skipLink">주메뉴바로가기</a></li>
          </ul>
        </div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">

            <div id="container-wrap" className="div-cont" >

              <div id="contents">
                <div className="app-header">
                  <p className="app-logo" onClick={() => {window.location.href = '/'}}><span className="blind">TOZ StudyCenter</span></p>
                  <a href="/" className="app-close"><span className="blind">닫기</span></a>
                </div>

                <div className="app-cont">
                  <div>
                    <div className="app-title">
                      <p className="stxt">차이를 만드는 독서실</p>
                      <p className="btxt">
                        <strong className="mgt">{this.state.title}</strong> 진행하는<br/>가까운 토즈를 찾아보세요.
                      </p>
                    </div>
                  </div>

                  <div className="sc-tit">{this.state.searchType === 'distance' ? '가까운 토즈를 찾아 주세요!' : '지역에 위치한 토즈를 찾아 주세요!'}</div>

                  <div className="appinfo-bbtn">
                    <a href={null} className={this.state.searchType === 'distance' ? 'current active' : 'current'} onClick={this._doSelectSearchTypeEvent.bind(this, 'distance')}>현 위치 기준</a>
                    <a href={null} className={this.state.searchType === 'location' ? 'area active' : 'area'} onClick={this._doSelectSearchTypeEvent.bind(this, 'location')}>지역 검색</a>
                  </div>

                  <CurrentPosLabel searchType={this.state.searchType} marginTop={this.state.searchType === 'distance' ? {marginTop: 0} : null} selSido={this.state.selSido} selSigungu={this.state.selSigungu} selDong={this.state.selDong} currSido={this.state.currSido} currSigungu={this.state.currSigungu} currDong={this.state.currDong} onClick={this._doOpenRequestFormPop} />

                  <div className="close-center">
                    <p className="title">{this.state.searchType === 'distance' ? '가장 가까운 센터' : '지역에 위치한 센터'}</p>
                    <ul className="list">
                      {this.state.branchList ? this.state.branchList.map((entity, index) => <EventBranchRow searchType={this.state.searchType} branch_id={entity.id} entity={entity} key={index} ref={this[`_branchRow${index}`]} onClick={this._doOpenRequestFormPop} />) : ''}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {!this.state.isOpenRegionPop ? '' : <BranchRegionPop sido={this.state.selSido} sigungu={this.state.selSigungu} dong={this.state.selDong} onClick={this._doCloseRequestFormPop} />}
        {!this.state.isOpenLocationPop ? '' : <BranchLocationPop branch_id={this.state.pop_branch_id} onClick={this._doCloseRequestFormPop} />}
      </div>
    )
  }
}

export default EventBranch;